<template>
	<BModal @close="() => $emit('close')">
		<p
			class="fsz-xl color-neutral-700 mb-60"
			v-html="
				$t(
					'A simulação está com o nome de ${name}. Quer salvar com outro nome?',
					{
						name: `<span class='color-primary-600'>${storeSimulationName}</span>`,
					}
				)
			"
		></p>

		<div class="d-grid--2 mb-60">
			<BFieldBlock label="Nome simulação"
				><BFieldText v-model="simulationName"
			/></BFieldBlock>
			<BFieldBlock label="Projeto"
				><BSelect v-model="project" :options="projectOptions"></BSelect>
			</BFieldBlock>
		</div>

		<div
			class="flex justify-end"
			:style="{
				gap: '16px',
			}"
		>
			<BBtn size="l" variant="text" @click="handleSkipClick">{{
				$t("Avançar Passo")
			}}</BBtn>
			<BBtn size="l" @click="handleSaveClick" :disabled="!isSaveBtnEnabled">{{
				$t("Salvar")
			}}</BBtn>
		</div>
	</BModal>
</template>

<script>
import { mapMutations, mapState } from "vuex";

import BSelect from "@/components/base/BSelect.vue";
import BFieldBlock from "@/components/base/BFieldBlock.vue";
import BModal from "@/components/base/BModal.vue";
import BBtn from "@/components/base/BBtn.vue";

import BFieldText from "../../components/base/BFieldText.vue";

export default {
	components: {
		BFieldBlock,
		BSelect,
		BModal,
		BFieldText,
		BBtn,
	},
	data() {
		return {
			projectOptions: [{ id: "1", label: "1" }],
			simulationName: "",
			project: null,
			isSimulationEdited: false,
		};
	},
	computed: {
		...mapState("simulator", {
			storeSimulationName: "simulationName",
			storeProject: "project",
		}),

		isSaveBtnEnabled() {
			return (
				this.project && this.simulationName.trim() && this.isSimulationEdited
			);
		},
	},

	methods: {
		...mapMutations("simulator", ["setSimulationName", "setSimulationProject"]),
		handleSkipClick() {},
		handleSaveClick() {
			this.setSimulationName(this.simulationName.trim());
			this.setSimulationProject(this.project);
		},
	},

	watch: {
		simulationName() {
			this.isSimulationEdited = true;
		},
	},

	created() {
		this.simulationName = this.storeSimulationName;
		this.project = this.storeProject;
	},
};
</script>
